import { IconButton, Typography } from "@mui/material";
import { ResultOf, graphql } from "@/config/graphql";
import { useQuery } from "@apollo/client";
import { useParams } from "react-router-dom";
import {
  NoContentContainer,
  Table,
  TableCell,
  TableContainer,
  TableRow,
} from "@/components/Table";
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";

export const transportationDetail = graphql(`
  query transportationDetail($params: ReportParams!) {
    report(params: $params) {
      id
      transportationControlDetails {
        id
        plate
        diesel
        lastOdometer
        chargeOdometer
        kms
        performance
        driver
      }
    }
  }
`);
interface TransportationControlReportProps {
  onEdit?: (
    detail: NonNullable<
      ResultOf<
        typeof transportationDetail
      >["report"]["transportationControlDetails"]
    >[number]
  ) => void;
}
export const TransportationTable = (
  props: TransportationControlReportProps
) => {
  const params = useParams();

  const { data } = useQuery(transportationDetail, {
    variables: { params: { id: +(params.id || 0) } },
    fetchPolicy: "cache-only",
  });
  return (
    <TableContainer>
      <Table>
        <thead>
          <TableRow variant="mainHeader">
            <TableCell sx={{ minWidth: 40 }}></TableCell>
            <TableCell>Patente</TableCell>
            <TableCell>Diesel [lt]</TableCell>
            <TableCell>Odómetro Carga [km]</TableCell>
            <TableCell>Último Odómetro [km]</TableCell>
            <TableCell>Kilómetros</TableCell>
            <TableCell>Rendimiento (km/lt)</TableCell>
          </TableRow>
        </thead>
        <tbody>
          {data?.report?.transportationControlDetails?.map((detail, index) => {
            return (
              <TableRow key={index} onClick={() => props.onEdit?.(detail)}>
                <TableCell>
                  {props.onEdit && (
                    <IconButton sx={{ color: "#333333" }}>
                      <CreateOutlinedIcon />
                    </IconButton>
                  )}
                </TableCell>
                <TableCell>
                  <Typography noWrap textAlign="center">
                    {detail.plate}
                  </Typography>
                  <Typography textAlign="center" variant="body2" fontSize={12}>
                    {detail.driver}
                  </Typography>
                </TableCell>
                <TableCell textAlign="center">
                  {detail.diesel?.toLocaleString("es-CL")}
                </TableCell>
                <TableCell textAlign="center">
                  {detail.chargeOdometer?.toLocaleString("es-CL")}
                </TableCell>
                <TableCell computedValue textAlign="center">
                  {detail.lastOdometer?.toLocaleString("es-CL")}
                </TableCell>
                <TableCell computedValue textAlign="center">
                  {detail.kms?.toLocaleString("es-CL")}
                </TableCell>
                <TableCell
                  computedValue
                  textAlign="center"
                  sx={(theme) => ({
                    color: !detail.performance
                      ? ""
                      : detail.performance < 1.8
                      ? theme.palette.error.main
                      : detail.performance >= 2
                      ? theme.palette.success.main
                      : theme.palette.warning.main,
                  })}
                >
                  {detail.performance?.toLocaleString("es-CL")}
                </TableCell>
              </TableRow>
            );
          })}
        </tbody>
      </Table>

      {data?.report.transportationControlDetails?.length === 0 && (
        <NoContentContainer>
          <Typography variant="body2">No hay transportes declarados</Typography>
        </NoContentContainer>
      )}
    </TableContainer>
  );
};
